var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopHeaderLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 673.988,
    height: 377.267,
    viewBox: "0 0 673.988 377.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17447",
    "data-name": "Group 17447",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M642.229,173.566V128.955H615.411v44.611H583.652V104.558h-23.29V52.976H541.308V0H501.786V52.976H482.731v51.582H460.147V42.52h-12.7V11.153H439.68V42.52H394.512V240.483H359.931V219.571H338.758v20.912H304.177V173.566H242.071V128.955H215.253v44.611h-1.411V259.3h-28.23V209.115H151.735V259.3h-28.23V104.558H101.628V52.976H21.172v51.582H0V377.1H673.988V173.566Z",
    transform: "translate(0)",
    fill: "#047baa",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 123.037)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 139.866) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 156.463)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 173.292) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 189.89)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 206.718) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 223.316)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 240.145) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 256.742)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 273.571) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 290.168)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 306.997) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 29.45,
    height: 16.829,
    transform: "translate(13.323 323.366)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 29.45,
    height: 16.829,
    transform: "translate(109.708 340.195) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 281.565)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 294.363)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 306.787)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 285.831)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 298.629)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 68.717,
    height: 8.414,
    transform: "translate(315.275 311.079)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 319.664)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 332.54)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 68.717,
    height: 8.414,
    transform: "translate(134.645 345.416)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 193.491)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 218.033) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 233.327)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 257.869) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 273.163)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 297.705) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 18.932,
    height: 24.542,
    transform: "translate(229.059 312.748)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 18.932,
    height: 24.542,
    transform: "translate(289.604 337.29) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 58.52)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 106.73)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 153.691)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 200.652)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 247.614)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 25.243,
    height: 32.255,
    transform: "translate(394.827 294.248)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 93.961,
    height: 27.347,
    transform: "translate(475.899 126.633)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.25 186.393)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.601 246.153)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 93.961,
    height: 27.347,
    transform: "translate(476.951 305.631)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 12.622,
    height: 26.646,
    transform: "translate(21.036 69.007)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 193.589)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 253.375)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 31.554,
    height: 40.669,
    transform: "translate(642.434 313.004)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(280.711 233.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M160.087,585.469s-34.109,20.579,28.767,52.262c0,0,13.864-25.717-1.464-46.687a20.649,20.649,0,0,0-26.787-5.87Z",
    transform: "translate(-150.851 -495.102)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M173.08,588.3s29.188,22.334,28.373,52.7",
    transform: "translate(-162.967 -498.367)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M236.726,561.074s-10.688-36.289,2.006-63a57.3,57.3,0,0,0,4.636-35.959,96.4,96.4,0,0,0-5.091-16.9",
    transform: "translate(-196.521 -417.276)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M242.925,395.529c0,4.449-8.054,17.33-8.054,17.33s-8.054-12.9-8.054-17.33a8.054,8.054,0,1,1,16.1,0Z",
    transform: "translate(-193.297 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M273.586,447.125c-2.417,3.734-16.186,10.181-16.186,10.181s.251-15.2,2.669-18.937a8.054,8.054,0,0,1,13.517,8.752Z",
    transform: "translate(-210.552 -413.838)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M268.41,540.4c-3.973,2-19.11.62-19.11.62s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-205.972 -464.26)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M251.334,614.623c-3.574,2.643-18.734,3.839-18.734,3.839s5.58-14.141,9.154-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-196.553 -506.015)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M215,470.388c3.189,3.1,18.053,6.308,18.053,6.308s-3.639-14.761-6.828-17.863A8.054,8.054,0,1,0,215,470.384Z",
    transform: "translate(-185.171 -425.884)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M193.11,554.687c3.973,2,19.11.619,19.11.619s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-171.771 -472.228)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M187.183,641.783c3.574,2.643,18.734,3.838,18.734,3.838s-5.58-14.146-9.159-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-169.086 -520.444)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M242.925,395.529c0,4.449-8.054,17.33-8.054,17.33s-8.054-12.9-8.054-17.33a8.054,8.054,0,1,1,16.1,0Z",
    transform: "translate(-193.297 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M273.586,447.125c-2.417,3.734-16.186,10.181-16.186,10.181s.251-15.2,2.669-18.937a8.054,8.054,0,0,1,13.517,8.752Z",
    transform: "translate(-210.552 -413.838)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M268.41,540.4c-3.973,2-19.11.62-19.11.62s7.889-13,11.862-15a8.053,8.053,0,1,1,7.253,14.381Z",
    transform: "translate(-205.972 -464.26)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M251.334,614.623c-3.574,2.643-18.734,3.839-18.734,3.839s5.58-14.141,9.154-16.788a8.054,8.054,0,1,1,9.579,12.95Z",
    transform: "translate(-196.553 -506.015)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M215,470.388c3.189,3.1,18.053,6.308,18.053,6.308s-3.639-14.761-6.828-17.863A8.054,8.054,0,1,0,215,470.384Z",
    transform: "translate(-185.171 -425.884)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M193.11,554.687c3.973,2,19.11.619,19.11.619s-7.889-13-11.862-15a8.053,8.053,0,1,0-7.253,14.381Z",
    transform: "translate(-171.771 -472.228)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M187.183,641.783c3.574,2.643,18.734,3.838,18.734,3.838s-5.58-14.146-9.159-16.788a8.054,8.054,0,1,0-9.579,12.95Z",
    transform: "translate(-169.086 -520.444)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(453.616 184.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1008.187,578.286s-14.271-48.455,2.679-84.119a76.515,76.515,0,0,0,6.19-48.015,128.721,128.721,0,0,0-6.8-22.561",
    transform: "translate(-974.457 -386.005)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1018.416,376.663c0,5.941-10.754,23.14-10.754,23.14s-10.754-17.222-10.754-23.14a10.754,10.754,0,1,1,21.5,0Z",
    transform: "translate(-972.069 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1049.063,429.277c-3.228,4.987-21.613,13.595-21.613,13.595s.336-20.3,3.564-25.286a10.754,10.754,0,1,1,18.049,11.686Z",
    transform: "translate(-984.944 -384.833)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1044.878,523.878c-5.305,2.673-25.518.827-25.518.827s10.534-17.355,15.839-20.028a10.753,10.753,0,1,1,9.685,19.2Z",
    transform: "translate(-981.534 -422.206)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1027.674,597.864c-4.773,3.529-25.014,5.125-25.014,5.125s7.451-18.882,12.224-22.417a10.754,10.754,0,1,1,12.791,17.292Z",
    transform: "translate(-974.495 -452.836)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M986.044,453.543c4.258,4.136,24.106,8.423,24.106,8.423s-4.859-19.709-9.117-23.852a10.755,10.755,0,1,0-14.989,15.429Z",
    transform: "translate(-966.117 -394.129)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M964.866,538.257c5.3,2.673,25.518.827,25.518.827s-10.535-17.355-15.84-20.028a10.754,10.754,0,0,0-9.678,19.2Z",
    transform: "translate(-956.173 -428.143)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M958.333,625.024c4.773,3.529,25.014,5.126,25.014,5.126s-7.451-18.882-12.224-22.417a10.754,10.754,0,1,0-12.791,17.292Z",
    transform: "translate(-953.974 -463.951)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(255.609 251.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M902.49,639.921s9.3-31.554-1.746-54.792a49.85,49.85,0,0,1-4.032-31.273,83.841,83.841,0,0,1,4.425-14.676",
    transform: "translate(-879.61 -514.446)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,515.242c0,3.871,7.012,15.083,7.012,15.083s7.012-11.219,7.012-15.083a7.012,7.012,0,1,0-14.024,0Z",
    transform: "translate(-878.058 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M910.456,544.065c2.1,3.247,14.08,8.856,14.08,8.856s-.217-13.225-2.321-16.471a7.012,7.012,0,1,0-11.759,7.615Z",
    transform: "translate(-907.371 -515.294)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M908.39,595.407c3.457,1.739,16.625.54,16.625.54s-6.865-11.3-10.315-13.042a7.012,7.012,0,0,0-6.311,12.509Z",
    transform: "translate(-904.8 -529.403)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M898.393,635.089c3.113,2.3,16.3,3.338,16.3,3.338s-4.852-12.3-7.965-14.6a7.012,7.012,0,0,0-8.33,11.261Z",
    transform: "translate(-888.177 -539.386)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M900.5,557.266c-2.8,2.693-15.7,5.49-15.7,5.49s3.162-12.839,5.939-15.532a7.012,7.012,0,1,1,9.761,10.048Z",
    transform: "translate(-868.633 -518.746)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M889.226,603.1c-3.457,1.739-16.625.54-16.625.54s6.865-11.3,10.315-13.042a7.012,7.012,0,0,1,6.311,12.51Z",
    transform: "translate(-850.022 -531.59)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M886.273,649.681c-3.113,2.3-16.3,3.338-16.3,3.338s4.88-12.306,7.966-14.606a7.012,7.012,0,0,1,8.33,11.268Z",
    transform: "translate(-844.264 -543.734)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M366.145,154.551H361.32a3.38,3.38,0,1,0,0-6.753H322.242a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.753a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,1,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-179.147 -121.118)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M612.145,275.551H607.32a3.38,3.38,0,1,0,0-6.753H568.242a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.752a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,1,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-251.597 -155.671)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1031.145,117.551h-4.824a3.38,3.38,0,1,0,0-6.753H987.243a3.38,3.38,0,0,0,0,6.753h4.824a3.38,3.38,0,1,0,0,6.753h-6.753a3.38,3.38,0,1,0,0,6.753h39.078a3.38,3.38,0,0,0,0-6.753h6.753a3.38,3.38,0,1,0,0-6.753Z",
    transform: "translate(-374.911 -110.062)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.714,465.94c-.54.393-.834.61-.834.61A3.551,3.551,0,0,0,519.714,465.94Z",
    transform: "translate(-238.823 -212.737)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.645,466.88c-.54.393-.835.61-.835.61A3.561,3.561,0,0,0,520.645,466.88Z",
    transform: "translate(-239.097 -213.009)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.645,465.94c-.54.393-.835.61-.835.61A3.556,3.556,0,0,0,520.645,465.94Z",
    transform: "translate(-239.097 -212.737)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(411.191 246.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1009.55,528.181s9.649-32.761-1.811-56.874a51.731,51.731,0,0,1-4.185-32.464,87.039,87.039,0,0,1,4.6-15.254",
    transform: "translate(-985.525 -398.178)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,373.1c0,4.017,7.271,15.645,7.271,15.645s7.271-11.644,7.271-15.645a7.271,7.271,0,1,0-14.538,0Z",
    transform: "translate(-981.411 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.719,423.827c2.182,3.372,14.613,9.192,14.613,9.192s-.227-13.725-2.409-17.1a7.271,7.271,0,1,0-12.2,7.9Z",
    transform: "translate(-1025.24 -393.777)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1023.363,517.285c3.587,1.807,17.253.559,17.253.559s-7.122-11.734-10.709-13.541a7.27,7.27,0,1,0-6.548,12.983Z",
    transform: "translate(-1019.36 -448.543)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1005.607,591.581c3.227,2.386,16.912,3.465,16.912,3.465s-5.038-12.766-8.264-15.156a7.271,7.271,0,1,0-8.648,11.691Z",
    transform: "translate(-994.733 -493.526)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M999.081,447.561c-2.879,2.8-16.3,5.695-16.3,5.695s3.286-13.326,6.164-16.126a7.272,7.272,0,1,1,10.134,10.431Z",
    transform: "translate(-965.724 -407.39)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M976.444,531.7c-3.587,1.807-17.252.559-17.252.559s7.122-11.734,10.709-13.541a7.271,7.271,0,0,1,6.543,12.982Z",
    transform: "translate(-935.492 -457.254)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M970.886,618.741c-3.227,2.386-16.912,3.465-16.912,3.465s5.038-12.766,8.265-15.156a7.271,7.271,0,1,1,8.648,11.691Z",
    transform: "translate(-927.004 -509.838)",
    fill: "#017572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopHeaderLeft);
export default __webpack_public_path__ + "static/media/desktop-header-left.ebcbf5c777abbb64fd56f32ee143a284.svg";
export { ForwardRef as ReactComponent };